var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.764 20.313C11.499 21.346 12 22 12 22s.5-.655 1.233-1.69C15.243 17.478 19 11.803 19 8.993 19 5.12 15.839 2 12 2S5 5.12 5 8.992c0 2.836 3.754 8.495 5.764 11.32zm1.233-1.722a74.525 74.525 0 001.812-2.724c.853-1.352 1.68-2.78 2.287-4.074.642-1.37.904-2.317.904-2.8C17 6.232 14.743 4 12 4S7 6.234 7 8.992c0 .496.263 1.449.905 2.818.606 1.294 1.433 2.72 2.285 4.07.63.995 1.261 1.93 1.807 2.71z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgZD0iTTEwLjc2NCAyMC4zMTNDMTEuNDk5IDIxLjM0NiAxMiAyMiAxMiAyMnMuNS0uNjU1IDEuMjMzLTEuNjlDMTUuMjQzIDE3LjQ3OCAxOSAxMS44MDMgMTkgOC45OTMgMTkgNS4xMiAxNS44MzkgMiAxMiAyUzUgNS4xMiA1IDguOTkyYzAgMi44MzYgMy43NTQgOC40OTUgNS43NjQgMTEuMzJ6bTEuMjMzLTEuNzIyYy41NDctLjc4NiAxLjE4LTEuNzI0IDEuODEyLTIuNzI0Ljg1My0xLjM1MiAxLjY4LTIuNzggMi4yODctNC4wNzQuNjQyLTEuMzcuOTA0LTIuMzE3LjkwNC0yLjhDMTcgNi4yMzIgMTQuNzQzIDQgMTIgNFM3IDYuMjM0IDcgOC45OTJjMCAuNDk2LjI2MyAxLjQ0OS45MDUgMi44MTguNjA2IDEuMjk0IDEuNDMzIDIuNzIgMi4yODUgNC4wNy42My45OTUgMS4yNjEgMS45MyAxLjgwNyAyLjcxeiIKICAgICAgICAgIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgogICAgPGNpcmNsZSBjeD0iMTIiIGN5PSI5IiByPSIyIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };